import type { TemplateOnlyComponent } from '@ember/component/template-only';

export interface Signature {
  Args: {
    class?: string;
  };
  Element: SVGElement;
}

const WrAiGeneratedIconComponent: TemplateOnlyComponent<Signature> = <template>
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    class={{@class}}
    ...attributes
  >
    <path
      d='M6.33333 10.5714C6.41533 10.5714 6.48737 10.6254 6.50938 10.7037C6.77709 11.6625 6.96322 11.8469 7.93294 12.1116C8.01185 12.1333 8.06667 12.2045 8.06667 12.2857C8.06667 12.3669 8.01231 12.4382 7.93294 12.4598C6.96327 12.7245 6.77713 12.9089 6.50938 13.8677C6.48737 13.946 6.41533 14 6.33333 14C6.25134 14 6.1793 13.946 6.15729 13.8677C5.88958 12.9089 5.70345 12.7246 4.73372 12.4598C4.65481 12.4382 4.6 12.3669 4.6 12.2857C4.6 12.2045 4.65435 12.1333 4.73372 12.1116C5.7034 11.8469 5.88953 11.6625 6.15729 10.7037C6.1793 10.6254 6.25134 10.5714 6.33333 10.5714ZM10.6667 3.71429C10.7553 3.71429 10.8335 3.77269 10.8571 3.85742C11.6012 6.52147 12.1616 7.07589 14.8561 7.81166C14.9412 7.83512 15 7.91244 15 8C15 8.08756 14.9417 8.16488 14.8561 8.18834C12.1621 8.9242 11.6011 9.47803 10.8571 12.1426C10.8335 12.2273 10.7553 12.2857 10.6667 12.2857C10.578 12.2857 10.4999 12.2273 10.4762 12.1426C9.73212 9.47853 9.17171 8.92411 6.47721 8.18834C6.39217 8.16488 6.33333 8.08756 6.33333 8C6.33333 7.91244 6.39168 7.83512 6.47721 7.81166C9.17121 7.0758 9.73221 6.52197 10.4762 3.85742C10.4999 3.7727 10.578 3.71429 10.6667 3.71429ZM3.6 2C3.70627 2 3.79921 2.07008 3.82767 2.1716C4.24123 3.65267 4.52934 3.93729 6.0265 4.34626C6.12872 4.37431 6.2 4.46626 6.2 4.57143C6.2 4.6766 6.12932 4.76855 6.0265 4.7966C4.52935 5.20551 4.24129 5.49076 3.82767 6.97126C3.79921 7.07277 3.70627 7.14286 3.6 7.14286C3.49373 7.14286 3.40079 7.07278 3.37233 6.97126C2.95877 5.49019 2.67066 5.20557 1.1735 4.7966C1.07128 4.76855 1 4.6766 1 4.57143C1 4.46626 1.07068 4.37431 1.1735 4.34626C2.67065 3.93735 2.95871 3.6521 3.37233 2.1716C3.40079 2.07008 3.49373 2 3.6 2Z'
      fill='currentColor'
    />
  </svg>
</template>;

export default WrAiGeneratedIconComponent;
